import { helper } from "@ember/component/helper";

export function accentColor(args) {
  switch (args[0]) {
    case "green":
      return args[1] == "dark" ? "text-green-700" : "text-green-200";
    case "indigo":
      return args[1] == "dark" ? "text-indigo-700" : "text-indigo-100";
    case "blue":
      return args[1] == "dark" ? "text-blue-700" : "text-blue-200";
    case "gray":
    default:
      return args[1] == "dark" ? "text-gray-500" : "text-gray-200";
  }
}

export default helper(accentColor);
